import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2;

import { useState, useEffect } from 'react';
import styled from '@xstyled/styled-components';
import { PrimaryButton, SecondaryButton, getSize, getColor } from '@lib/common';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var StyledButtonGroup = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: ", " 0 150px;\n  flex-grow: 2;\n"])), getSize('padding24'));
var StyledProgressText = styled.span(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  font-size: ", ";\n  font-weight: 600;\n  color: ", ";\n"])), getSize('typo14'), getColor('contentBody'));
export var QuestionDisplayAsCarousel = function QuestionDisplayAsCarousel(_ref) {
  var items = _ref.items,
      activeQuestionIndex = _ref.activeQuestionIndex,
      onQuestionIndexChange = _ref.onQuestionIndexChange,
      onPreviousSection = _ref.onPreviousSection,
      onNextSection = _ref.onNextSection,
      _ref$isFirstSection = _ref.isFirstSection,
      isFirstSection = _ref$isFirstSection === void 0 ? false : _ref$isFirstSection,
      _ref$isLastSection = _ref.isLastSection,
      isLastSection = _ref$isLastSection === void 0 ? false : _ref$isLastSection,
      navigationLabels = _ref.navigationLabels;

  var _useState = useState(activeQuestionIndex !== null && activeQuestionIndex !== void 0 ? activeQuestionIndex : 0),
      currentIndex = _useState[0],
      setCurrentIndex = _useState[1];

  useEffect(function () {
    if (activeQuestionIndex !== undefined && activeQuestionIndex >= 0) {
      setCurrentIndex(activeQuestionIndex);
    }
  }, [activeQuestionIndex]);
  useEffect(function () {
    if (activeQuestionIndex === undefined) {
      setCurrentIndex(0);
    }
  }, [items.length]);

  if (!items || items.length === 0) {
    return null;
  }

  var isFirstQuestion = currentIndex === 0;
  var isLastQuestion = currentIndex === items.length - 1;

  var handlePrevious = function handlePrevious() {
    if (isFirstQuestion) {
      onPreviousSection === null || onPreviousSection === void 0 ? void 0 : onPreviousSection();
    } else {
      var newIndex = currentIndex - 1;
      setCurrentIndex(newIndex);
      onQuestionIndexChange === null || onQuestionIndexChange === void 0 ? void 0 : onQuestionIndexChange(newIndex);
    }
  };

  var handleNext = function handleNext() {
    if (isLastQuestion) {
      onNextSection === null || onNextSection === void 0 ? void 0 : onNextSection();
    } else {
      var newIndex = currentIndex + 1;
      setCurrentIndex(newIndex);
      onQuestionIndexChange === null || onQuestionIndexChange === void 0 ? void 0 : onQuestionIndexChange(newIndex);
    }
  };

  var leftButtonDisabled = isFirstQuestion && isFirstSection;
  var rightButtonDisabled = isLastQuestion && isLastSection;
  var leftButtonText = isFirstQuestion ? (navigationLabels === null || navigationLabels === void 0 ? void 0 : navigationLabels.previousSection) || 'Previous Section' : (navigationLabels === null || navigationLabels === void 0 ? void 0 : navigationLabels.previousQuestion) || 'Previous Question';
  var rightButtonText = isLastQuestion ? (navigationLabels === null || navigationLabels === void 0 ? void 0 : navigationLabels.nextSection) || 'Next Section' : (navigationLabels === null || navigationLabels === void 0 ? void 0 : navigationLabels.nextQuestion) || 'Next Question';
  var progressText = navigationLabels !== null && navigationLabels !== void 0 && navigationLabels.questionOfTotal ? navigationLabels.questionOfTotal(currentIndex + 1, items.length) : "".concat(currentIndex + 1, " / ").concat(items.length);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("div", {
      children: items[currentIndex]
    }), /*#__PURE__*/_jsxs(StyledButtonGroup, {
      children: [/*#__PURE__*/_jsx(SecondaryButton, {
        disabled: leftButtonDisabled,
        onClick: handlePrevious,
        children: leftButtonText
      }), /*#__PURE__*/_jsx(StyledProgressText, {
        children: progressText
      }), /*#__PURE__*/_jsx(PrimaryButton, {
        disabled: rightButtonDisabled,
        onClick: handleNext,
        children: rightButtonText
      })]
    })]
  });
};